import { render, staticRenderFns } from "./If.vue?vue&type=template&id=44962c07&scoped=true&"
import script from "./If.vue?vue&type=script&lang=js&"
export * from "./If.vue?vue&type=script&lang=js&"
import style0 from "./If.vue?vue&type=style&index=0&id=44962c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44962c07",
  null
  
)

export default component.exports